import React from 'react';
type SectionProps = {
  id?: string;
  className?: string;
  children: React.ReactNode;
  labelledBy?: string;
};
export function Section({
  id,
  className = '',
  children,
  labelledBy
}: SectionProps) {
  return <section id={id} aria-labelledby={labelledBy} className={`relative w-full ${className}`} data-id="element-465" data-mp="2vx16lmhni7ui">
      {children}
    </section>;
}
export function Container({
  className = '',
  children
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <div className={`mx-auto w-full max-w-6xl px-5 sm:px-8 ${className}`} data-id="element-466" data-mp="35wryrhiqoarf">{children}</div>;
}
export function Eyebrow({
  children,
  tone = 'navy',
  className = ''
}: {
  children: React.ReactNode;
  tone?: 'navy' | 'light';
  className?: string;
}) {
  return <p className={`font-meta text-xs font-semibold uppercase tracking-[0.18em] ${tone === 'navy' ? 'text-brand-navy' : 'text-brand-blue'} ${className}`} data-id="element-467" data-mp="3avczrj5teygx">
      {children}
    </p>;
}